import React from 'react';
import Button from '@mui/material/Button';

export default function VButton(props) {
  return <Button disableElevation {...props} />;
}

